// First-visit helpers, switched off for all customers (Mike 2026-10-08, "ausblenden"): the Cockpit tour is
// outdated, and the first hotel customer logs in from 2026-10-09. The automatic start is off and, since the
// Hotel-Edition (PLAN §1 item 1), the sidebar entries "Cockpit-Tour" / "Willkommensvideo" are gone too; the
// components stay in the code. A new, personalised short tour comes later — flip these back (or replace them) then.
export const DASHBOARD_TOUR_AUTO_START = false;
export const WELCOME_VIDEO_AUTO_OPEN = false;

/** Sidebar entries hidden for everyone (the routes still exist). */
export const HIDDEN_NAV_URLS: ReadonlySet<string> = new Set(["/team"]);

export function isNavItemHidden(url: string): boolean {
  return HIDDEN_NAV_URLS.has(url);
}

/** Auto-open the welcome video on the dashboard? Never while WELCOME_VIDEO_AUTO_OPEN is off. */
export function shouldAutoOpenWelcomeVideo(hasSeenVideo: string | null, isOnboarded: boolean | null | undefined): boolean {
  return WELCOME_VIDEO_AUTO_OPEN && !hasSeenVideo && !!isOnboarded;
}

/** Hotels never get the old welcome video or Cockpit tour, neither automatically nor on a manual start event
 *  (Mike 2026-10-10; a new Cockpit walkthrough replaces both, GTD #80). Agencies unchanged: components stay
 *  mounted, so their (switched-off) auto start and manual events behave as before. */
export function mountsLegacyTourAndVideo(isHotel: boolean): boolean {
  return !isHotel;
}
